export default [
    {
        type: 1,
        label: {
            en: 'Cash',
            et: 'Sularaha',
            ru: 'Наличные деньги',
            lv: "Skaidra nauda",
            lt: "Grynieji",
            fi: "Käteinen",
        },
    },
    {
        type: 3,
        label: {
            en: 'Bank card',
            et: 'Pangakaart',
            ru: 'Банковская карта',
            lv: "Bankas karte",
            lt: "Banko kortelė",
            fi: "Pankkikortti",
        },
    },
    {
        type: 5,
        label: {
            en: 'Bank transfer',
            et: 'Pangaülekanne',
            ru: 'Банковский перевод',
            lv: "Bankas pārskaitījums",
            lt: "Bankinis pavedimas",
            fi: "Tilisiirto",
        },
    },
]